<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'About'"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<div class="banner_el"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img src="../../assets/img/about/banner_1.webp" />
					<div class="msg_box">
						<div class="title"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>About Us</div>
						<div class="text"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>
							From antigens and antibodies to NC membranes and customizable rapid testing solutions,<br />
							we specialize in developing high-quality raw materials and offering comprehensive medical<br />
							device solutions.
						</div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--位置-->
			<div class="location_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-icon name="wap-home" class="icon" color="#808080" size="20px" />
				<span @click="goHome" style="cursor: pointer;">Home</span>
				<van-icon name="arrow" class="icon" color="#808080" size="18px" />
				<span style="color: #808080;">About</span>
			</div>
			<!--位置-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>UC reagent</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						UC reagent is a multinational biotechnology company based in San Diego well known for R&D and fully personalizable medical diagnostic products. Founded in 2006, UC reagent focuses primarily on raw material development and medical device marketing through world-class research, development, manufacturing and operations teams.
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						UC reagent provides high quality, competitively priced products and services with fully customizable solutions for any research, production and medical diagnostic needs.
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
					>
						UC reagent production base, located in Bao Ruiyuan Industrial Park, China, contains a GMP, ISO certified factory with full-scale production line and supporting facilities. The current production line provides products for over 100 countries, with milions of users worldwide.
						<!-- In China, our products are manufactured under the name Ruyun®, Hongxia®, Jingshi®, which hold a strong market share in the area. -->
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="600"
						data-aos-offset="0"
						data-aos-once="true"
					>
						UC reagent is a global supplier of GMP-grade reagents and raw materials, offering variety of antigens and antibodies, positive controls, nitrocellulose (NC) membranes and more. With over 20 years of research and development, we have produced thousands of GMP-grade reagents. These products can be used for in vitro diagnostics, genetic screening, cell culture, preclinical or clinical research.
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="600"
						data-aos-offset="0"
						data-aos-once="true"
					>
						UC reagent is independent from the University of California system.
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">Our Products</div>
					<div class="msg_box">
						<div class="left">
							<div class="cate_box">
								<div class="cate_list">
									<div class="cate_list_el" @click="goProducts(1, productType[0])" style="padding: 0;font-weight: bold;">
										<div>{{ productType[0].title }}</div>
										<img src="../../assets/img/about/icon_1.webp" />
									</div>
								</div>
							</div>
						</div>
						<div class="right">
							<div class="cate_box">
								<div class="cate_list">
									<div class="cate_list_el" @click="goProducts(1, productType[1])" style="padding: 0;font-weight: bold;">
										<div>{{ productType[1].title }}</div>
										<img src="../../assets/img/about/icon_1.webp" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="msg_box">
						<div class="left">
							<div class="cate_box">
								<!-- <div class="tab_box">
									<div v-for="(value, index) in productType" :key="index" class="tab_el actived" style="margin-right: 5px;" @click="goProducts(1, value)">{{ value.title }}</div>
								</div> -->
								<div class="title_box">Products Type</div>
								<div class="cate_list">
									<div v-for="(value, index) in productList" :key="index" class="cate_list_el" @click="goProducts(2, value)">
										<div>{{ value.title }}</div>
										<img src="../../assets/img/about/icon_1.webp" />
									</div>
								</div>
							</div>
						</div>
						<div class="right">
							<div class="cate_box">
								<div class="title_box">Products Type</div>
								<div class="cate_list">
									<div v-for="(value, index) in productList2" :key="index" class="cate_list_el" @click="goProducts(2, value)">
										<div>{{ value.title }}</div>
										<img src="../../assets/img/about/icon_1.webp" />
									</div>
								</div>
							</div>
							<div class="cate_box" style="margin-top: 20px;">
								<div class="title_box">Tested Apps</div>
								<div class="cate_list">
									<div v-for="(value, index) in appsList" :key="index" class="cate_list_el" @click="goProducts(3, value)">
										<div>{{ value.title }}</div>
										<img src="../../assets/img/about/icon_1.webp" />
									</div>
								</div>
							</div>
							<div v-if="false" class="cate_box" style="margin-top: 20px;">
								<div class="cate_list">
									<div class="title_box">Devices</div>
									<div class="cate_list_el">
										<div>Viral and infectious disease</div>
										<img src="../../assets/img/about/icon_1.webp" />
									</div>
									<div class="cate_list_el">
										<div>Viral and infectious disease</div>
										<img src="../../assets/img/about/icon_1.webp" />
									</div>
									<div class="cate_list_el">
										<div>Viral and infectious disease</div>
										<img src="../../assets/img/about/icon_1.webp" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">Nitrocellulose (NC) Membranes</div>
					<div class="msg_box">
						<div class="left">
							<div class="left_left">
								<div class="el">● Membrane iM90</div>
								<div class="el">● Membrane iM120</div>
								<div class="el">● i-Membrane Customized</div>
							</div>
							<div class="left_right">
								<div class="el">● Membrane iM95</div>
								<div class="el">● Membrane iM125</div>
								<div class="btn_box" @click="goIm">
									Learn More&nbsp;&nbsp;<van-icon name="down" class="icon" size="18" color="#E37542" />
								</div>
							</div>
						</div>
						<div class="right">
							<img src="../../assets/img/about/block_1.webp" />
						</div>
					</div>
					<div class="bot">
						<img src="../../assets/img/about/block_2.webp" />
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div v-if="false" class="block_4">
				<div class="block_4_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="left">CLIA Lab Testing</div>
					<div class="right">
						<div v-for="(value, index) in servicesList" :key="index" @click="goServices">● {{ value.name }}</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div v-if="false" class="block_5">
				<div class="block_5_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit_box">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="tit"
						>
							UC reagent is part of CorDx Union，<br />a Global Innovator in Biotechnology and Beyond
						</div>
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="txt"
						>
							CorDx Union is a global biotechnology power that delivers solutions in healthcare, energy, AI quality management, and other innovative industries. From life’s conception to its completion, CU aims to provide end-to-end support through complete supply chain resources and services. UC reagent is part of CorDx Union (CU) totaling 21 subsidiaries under the CU umbrella.
						</div>
					</div>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="num_box"
					>
						<div class="num_el">
							<div class="tit">
								<count-to :startVal="0" :endVal="25000" :duration="6000" separator="" class="num"></count-to>
								<span class="tips">+</span>
							</div>
							<div class="txt">25,000m² industrial</div>
						</div>
						<div class="num_el">
							<div class="tit">
								<count-to :startVal="0" :endVal="1000" :duration="6000" separator="" class="num"></count-to>
								<span class="tips">+</span>
							</div>
							<div class="txt">Global Business Partners</div>
						</div>
						<div class="num_el">
							<div class="tit">
								<count-to :startVal="0" :endVal="15" :duration="3000" separator="" class="num"></count-to>
								<span class="tips">+</span>
							</div>
							<div class="txt">Years of Experience</div>
						</div>
						<div class="num_el">
							<div class="tit">
								<count-to :startVal="0" :endVal="800" :duration="5000" separator="" class="num"></count-to>
								<span class="tips">+</span>
							</div>
							<div class="txt">Innovative Products</div>
						</div>
					</div>
					<div class="web_box">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="tit"
						>Our Organization</div>
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="block_5_box"
						>
							<div class="block_5_el">
								<a href="https://cordx.com/" target="_blank">
									<img src="../../assets/img/about/web1.webp" />
									<div class="tit">CorDx</div>
									<div class="txt">Diagnostic platform for innovation, manufacturing, and supply.</div>
								</a>
							</div>
							<div class="block_5_el">
								<a href="https://coretests.com/" target="_blank">
									<img src="../../assets/img/about/web2.webp" />
									<div class="tit">Core tests</div>
									<div class="txt">Precision, reliable, and use-friendly testing solutions for IVD and more.</div>
								</a>
							</div>
							<div class="block_5_el" style="cursor: auto;">
								<img src="../../assets/img/about/web3.webp" />
								<div class="tit">Accu News</div>
								<div class="txt">Manufacture pharmaceutical preparations, instruments, testers and more</div>
							</div>
							<div class="block_5_el">
								<a href="https://www.abiores.com/en/" target="_blank">
									<img src="../../assets/img/about/web4.webp" />
									<div class="tit">Abiores</div>
									<div class="txt">PCR solutions for diagnostic testing, research, and development.</div>
								</a>
							</div>
							<div class="block_5_el">
								<a href="https://bonore.com/" target="_blank">
									<img src="../../assets/img/about/web5.webp" />
									<div class="tit">Bono Plastics</div>
									<div class="txt">Consumable supplies and resources for diagnostic production and development.</div>
								</a>
							</div>
							<div class="block_5_el">
								<a href="https://en.cupet.com/" target="_blank">
									<img src="../../assets/img/about/web6.webp" />
									<div class="tit">CuPet</div>
									<div class="txt">One-Stop Animal Diagnostic Solutions.</div><br />
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import CountTo from 'vue-count-to';
import { getAbout } from '@/api/public';
export default {
	components:{
		navBox,
		footerBox,
		CountTo
	},
	data() {
		return {
			isLoading: true,  //界面loading
			productType: [],
			productList: [],
			productList2: [],
			appsList: [],
			servicesList: []
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navData')) {
			that.productType = JSON.parse(sessionStorage.getItem('navData')).cate_list;
			// that.productList = JSON.parse(sessionStorage.getItem('navData')).diseases_list;
			that.appsList = JSON.parse(sessionStorage.getItem('navData')).apps_list;
			that.servicesList = JSON.parse(sessionStorage.getItem('navData')).service_list;
		}
	},
	mounted() {
		let that = this;
		getAbout().then(res => {
			that.productList = res.data.diseases_list;
			that.productList2 = res.data.diseases_lists;
			that.isLoading = false;
		});
	},
	methods: {
		//跳转产品
		goProducts(type, value) {
			let that = this;
			switch(type) {
				case 1:
					that.$router.push({ path: '/products', query: { type: value.id } });
				break;
				case 2:
					that.$router.push({ path: '/products', query: { disease: value.id } });
				break;
				case 3:
					that.$router.push({ path: '/products', query: { tests: value.id } });
				break;
			}
		},
		//跳转服务
		goServices() {
			this.$router.push('/services');
		},
		//跳转im
		goIm() {
			window.open('https://i-membrane.com/');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	//块5
	.block_5{
		.block_5_main{
			padding: 80px 0 80px 0;
			.web_box{
				width: 1140px;
				margin: 0 auto;
				.block_5_box{
					padding-top: 0px;
					.block_5_el:hover{
						img{
							transform: scale(1.3);
						}
					}
					.block_5_el{
						width: 31%;
						display: inline-block;
						margin: 10px;
						padding: 20px 35px;
						background-color: #ffffff;
						text-align: center;
						border-radius: 10px;
						border: 1px solid #CCCCCC;
						cursor: pointer;
						.btn{
							padding: 20px 0 10px 0;
							.btn_box{
								padding: 4px 16px 1px 16px;
								border: 1px solid #1E5D84;
								span{
									font-size: 16px;
								}
							}
						}
						.txt{
							padding-top: 10px;
							font-size: 15px;
							color: #706B69;
						}
						.tit{
							font-size: 20px;
							color: #000000;
						}
						img{
							width: 70%;
							transition: all 0.3s;
						}
					}
				}
				.tit{
					padding-bottom: 10px;
					font-size: 40px;
					text-align: center;
				}
			}
			.num_box{
				display: flex;
				width: 1140px;
				margin: 0 auto;
				padding: 50px 0 80px 0;
				.num_el{
					flex: 1;
					text-align: center;
					.txt{
						color: #E37542;
						font-size: 16px;
					}
					.tit{
						position: relative;
						.num{
							font-size: 54px;
							color: #006BB3;
							line-height: 1;
						}
						span.tips{
							position: absolute;
							top: -10px;
							color: #006BB3;
							font-size: 34px;
						}
					}
				}
			}
			.tit_box{
				width: 1140px;
				margin: 0 auto;
				text-align: center;
				.txt{
					padding-top: 10px;
					font-size: 18px;
				}
				.tit{
					font-size: 40px;
				}
			}
		}
	}
	//块4
	.block_4{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		background-color: #E37542;
		.block_4_main{
			display: flex;
			align-items: center;
			padding: 30px 0;
			.right{
				flex: 1;
				padding-left: 40px;
				div{
					padding: 5px 0;
					color: #ffffff;
					font-size: 18px;
					cursor: pointer;
				}
			}
			.left{
				flex: 1;
				padding-right: 40px;
				color: #ffffff;
				font-size: 40px;
				text-align: right;
			}
		}
	}
	//块3
	.block_3{
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			padding: 68px 0 70px 0;
			.bot{
				margin-top: 20px;
				overflow: hidden;
				img:hover{
					transform: scale(1.3);
				}
				img{
					width: 100%;
					transition: all 0.6s;
				}
			}
			.msg_box{
				display: flex;
				align-items: center;
				padding-top: 30px;
				.left{
					flex: 1;
					display: flex;
					margin-right: 10px;
					.left_right{
						flex: 1;
						.btn_box{
							margin-top: 5px;
							font-size: 18px;
							color: #E37542;
							cursor: pointer;
							user-select: none;
							.icon{
								top: 3px;
								transform: rotate(-90deg);
							}
						}
					}
					.left_left{
						flex: 1;
					}
					.el{
						padding: 5px 0;
						font-size: 20px;
					}
				}
				.right{
					flex: 1;
					margin-left: 10px;
					overflow: hidden;
					img:hover{
						transform: scale(1.3);
					}
					img{
						width: 100%;
						transition: all 0.6s;
					}
				}
			}
			.title{
				font-size: 48px;
				text-align: center;
			}
		}
	}
	//块2
	.block_2{
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			.msg_box{
				display: flex;
				padding-top: 20px;
				.right{
					flex: 1;
					padding-left: 10px;
				}
				.left{
					flex: 1;
					padding-right: 10px;
				}
				.cate_box{
					padding: 30px;
					background-color: #F6F6F6;
					.tab_box{
						display: flex;
						.tab_el.actived{
							background-color: rgba(0, 107, 179, 1);
						}
						.tab_el{
							flex: 1;
							margin-bottom: 24px;
							padding: 15px 0 10px 0;
							border-radius: 6px;
							text-align: center;
							font-size: 20px;
							color: #ffffff;
							cursor: pointer;
							background-color: rgba(0, 107, 179, 0.6);
						}
					}
					.title_box{
						// margin-bottom: 24px;
						// padding: 15px 0 10px 0;
						margin-bottom: 10px;
						padding-bottom: 16px;
						border-bottom: 1px solid #CCCCCC;
						font-size: 18px;
						color: #808080;
					}
					.cate_list{
						.cate_list_el:hover{
							img{
								transform: translateX(8px);
							}
							div{
								color: #006BB3;
							}
						}
						.cate_list_el:last-child{
							padding-bottom: 0;
						}
						.cate_list_el{
							display: flex;
							align-items: center;
							padding: 10px 0;
							cursor: pointer;
							// border-bottom: 1px solid #E2E2E2;
							img{
								width: 18px;
								transition: all 0.3s;
							}
							div{
								flex: 1;
								font-size: 18px;
							}
						}
					}
				}
			}
			.title{
				font-size: 48px;
				text-align: center;
			}
		}
	}
	//块1
	.block_1{
		.block_1_main{
			width: 1140px;
			margin: 0 auto;
			padding: 68px 0 75px 0;
			.txt{
				padding-top: 24px;
				font-size: 18px;
			}
			.tit{
				font-size: 28px;
			}
			.title{
				font-size: 48px;
				color: #006BB3;
			}
		}
	}
	//位置块
	.location_box{
		width: 1140px;
		margin: 0 auto;
		padding-top: 30px;
		.icon{
			top: 4px;
		}
		span{
			display: inline-block;
			padding: 0 5px;
			font-size: 16px;
		}
	}
	//banner
	.banner_box{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		.banner_el{
			position: relative;
			.msg_box{
				width: 100%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				text-align: center;
				.text{
					font-size: 24px;
					color: #ffffff;
				}
				.title{
					font-size: 56px;
					color: #ffffff;
				}
			}
			img{
				width: 100%;
				min-width: 1140px;
			}
		}
	}
}
</style>